import script from "./InsuranceSuccessPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./InsuranceSuccessPage.vue?vue&type=script&setup=true&lang=ts"

import "./InsuranceSuccessPage.vue?vue&type=style&index=0&id=20b3e076&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20b3e076"]])

export default __exports__